import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, fill, outline, gradient }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  return (
    <g transform={`scale(${scaleX},1)`}>
      <path
        d="M73.3516 10.8121C74.3816 5.09206 76.1216 1.49205 78.7916 1.05205C82.6716 0.412053 86.3716 5.59201 80.9016 21.132C78.7216 27.312 76.5016 29.6321 74.6816 29.2421C71.6916 28.6121 71.2816 22.3821 73.3516 10.8121Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M81.5415 13.312C81.5415 13.312 81.8915 7.70197 80.1015 6.32197C78.5915 5.15197 76.9415 8.58199 74.7915 21.842"
        fill={`url(#${randomGradientId1})`}
      />
      <path
        d="M81.5415 13.312C81.4715 12.282 81.3915 11.252 81.2215 10.242C81.0615 9.24202 80.8515 8.23194 80.4115 7.40194C80.2115 7.01194 79.8615 6.62198 79.6215 6.57198C79.4715 6.49198 79.1615 6.76194 78.9215 7.15194C78.4315 7.93194 78.1115 8.92192 77.8015 9.88192C77.2015 11.8219 76.7315 13.822 76.2515 15.822C75.7815 17.822 75.3115 19.832 74.7915 21.842C74.9415 19.772 75.1715 17.722 75.5015 15.672C75.8315 13.632 76.2415 11.592 76.8515 9.58199C77.1715 8.58199 77.5015 7.58191 78.1215 6.62191C78.2815 6.38191 78.4715 6.14197 78.7415 5.93197C78.9915 5.72197 79.4615 5.55198 79.8715 5.69198C80.6315 5.97198 80.9015 6.53195 81.1615 7.04195C81.6015 8.09195 81.7115 9.15198 81.7515 10.192C81.7515 11.242 81.7115 12.282 81.5415 13.312Z"
        fill={outline}
      />
      <path
        d="M11.3119 10.8921C10.2819 5.17208 8.54188 1.57213 5.87188 1.13213C1.99188 0.49213 -1.70812 5.67215 3.76188 21.2121C5.94188 27.3921 8.16188 29.7121 9.98188 29.3221C12.9719 28.6921 13.3819 22.4621 11.3119 10.8921Z"
        fill={fill}
        stroke={outline}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M3.1219 13.382C3.1219 13.382 2.7719 7.77204 4.5619 6.39204C6.0719 5.22204 7.7219 8.65206 9.8719 21.9121"
        fill={`url(#${randomGradientId2})`}
      />
      <path
        d="M3.12212 13.382C2.95212 12.352 2.90212 11.312 2.92212 10.262C2.96212 9.21204 3.07212 8.15214 3.51212 7.11214C3.77212 6.61214 4.04212 6.05204 4.80212 5.76204C5.21212 5.62204 5.67212 5.79203 5.93212 6.00203C6.20212 6.21203 6.39212 6.4521 6.55212 6.6921C7.16212 7.6521 7.50212 8.65206 7.82212 9.65206C8.42212 11.6621 8.84212 13.6921 9.17212 15.7421C9.51212 17.7821 9.73212 19.8421 9.88212 21.9121C9.36212 19.9021 8.89212 17.902 8.42212 15.892C7.94212 13.892 7.47212 11.8921 6.87212 9.95211C6.56212 9.00211 6.24212 8.01213 5.75212 7.22213C5.50212 6.83213 5.19212 6.56205 5.05212 6.64205C4.81212 6.69205 4.46212 7.08213 4.26212 7.47213C3.83212 8.30213 3.61212 9.31209 3.45212 10.3121C3.27212 11.3221 3.19212 12.352 3.12212 13.382Z"
        fill={outline}
      />
      <defs>
        <radialGradient
          id={randomGradientId1}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(77.1447 3.66508) rotate(-178.538) scale(11.676 15.2422)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
        <radialGradient
          id={randomGradientId2}
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(7.59831 3.66621) rotate(-1.46169) scale(11.676 15.2422)"
        >
          <stop stopColor={gradient[0]} />
          <stop offset="1" stopColor={gradient[1]} />
        </radialGradient>
      </defs>
    </g>
  )
}
